export function arrayToMap<Type>(key: keyof Type, arr: Type[]): Map<Type[keyof Type], Type> {
  return new Map(arr.map((item) => [item[key], item]));
}
